<script>
import { usePortalStore } from '../../stores/portal'
export default {
  props: {
    name: String
  },
  data () {
    return {
      portalStore: usePortalStore()
    }
  },
  computed: {
    portal () {
      return this.portalStore.portals[this.name] ?? {}
    },
    content () {
      return Object.values(this.portal)
    }
  },
  render (h) {
    return h('div', this.content)
  }
}
</script>
